var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "view-point" }, [
    _c(
      "dl",
      [
        _c("div", {
          staticClass: "viewpoints-img",
          style:
            "background: url(" +
            _vm.userOfferImageUrlForSp +
            "/ttl_view_point.png) no-repeat center;",
        }),
        _vm._v(" "),
        _c(
          "dt",
          {
            style:
              "background: url(" +
              _vm.userOfferImageUrlForSp +
              "/view_point_line.png) repeat-x bottom;",
          },
          [_vm._v("\n      女の転職！取材レポート\n    ")]
        ),
        _vm._v(" "),
        _vm.report.name
          ? _c(
              "dd",
              {
                staticClass: "report-title fs12 fb",
                attrs: { "data-test": "name" },
              },
              [
                _vm._v(
                  "\n      取材担当" + _vm._s(_vm.report.name) + "より\n    "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("dd", {
          staticClass: "pega-pre-wrap",
          domProps: { textContent: _vm._s(_vm.report.body) },
        }),
        _vm._v(" "),
        _vm.report.improve
          ? [
              _c(
                "dd",
                {
                  staticClass: "report-title fs12 fb",
                  attrs: { "data-test": "improve-title" },
                },
                [_vm._v("\n        この仕事で磨ける経験・能力\n      ")]
              ),
              _vm._v(" "),
              _c("dd", {
                staticClass: "pega-pre-wrap",
                attrs: { "data-test": "improve" },
                domProps: { textContent: _vm._s(_vm.report.improve) },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.interviews.length
          ? _c(
              "dl",
              {
                staticClass: "view-msg mt15 pt15 pb15 plr15",
                attrs: { "data-test": "interviews" },
              },
              [
                _c(
                  "dt",
                  {
                    staticClass: "viewpoints-title",
                    style:
                      "background: url(" +
                      _vm.userOfferImageUrlForSp +
                      "/view_point_line.png) repeat-x bottom;",
                  },
                  [_vm._v("\n        社員の方にインタビューしました\n      ")]
                ),
                _vm._v(" "),
                _vm._l(_vm.interviews, function (interview, i) {
                  return [
                    i
                      ? _c("span", {
                          key: "bar-" + i,
                          staticClass: "viewpoints-bar mt15",
                          attrs: { "data-test": "bar-" + i },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    interview.title
                      ? _c(
                          "dt",
                          {
                            key: "title-" + i,
                            staticClass: "viewpoints-title-normal mt15 fs12",
                            attrs: { "data-test": "title-" + i },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(interview.title) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("dd", { key: "body-" + i }, [
                      interview.photo
                        ? _c("img", {
                            staticClass:
                              "offer-img-sub-interview image-height-auto mb15",
                            attrs: {
                              src: _vm.getPhotoUrl(interview.photo),
                              "data-test": "photo-" + i,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "pega-pre-wrap",
                        attrs: { "data-test": "body-" + i },
                        domProps: { textContent: _vm._s(interview.body) },
                      }),
                    ]),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }